export const EstadoRegistro = Object.freeze({
    ACTIVO: "ACTIVO",
    INACTIVO: "INACTIVO",
    ELIMINADO: "ELIMINADO",
    CESADO: "CESADO",
    PENDIENTE_APROBAR: "PENDIENTE_APROBAR",
    PENDIENTE_COMPLETAR: "PENDIENTE_COMPLETAR"
});
